<template>
    <div>
        <!-- modal -->
        <matter-form ref="lawMatterForm"></matter-form>   
        <b-modal id="clientsReportsFormModal" ref="clientsReportsFormModal" centered size="xl" no-close-on-backdrop hide-footer>
        <template #modal-title>
            <div>
                <div style="font-weight:bold;">{{ $t('clientsReports.files') }}</div>
                <div style="font-size: smaller; color:#6B7280;">{{ subtitle }}</div>
            </div>
        </template>
        <!-- table -->
        <b-row class="mb-1">
            <b-col cols="3">
                <div style="background-color:#F3F4F6; border-radius:6px; padding:10px;">
                    <div style="font-size:13px; color:#6B7280;">{{ $t('clientsReports.summary_files') }}</div>
                    <div style="font-size:24px; color:#111827;">{{ fileCount }}</div>
                </div>
            </b-col>
            <b-col cols="3">
                <div style="background-color:#F3F4F6; border-radius:6px; padding:10px;">
                    <div style="font-size:13px; color:#6B7280;">{{ $t('clientsReports.summary_open') }}</div>
                    <div style="font-size:24px; color:#111827;">{{ openCount }}</div>
                </div>
            </b-col>
            <b-col cols="3">
                <div style="background-color:#F3F4F6; border-radius:6px; padding:10px;">
                    <div style="font-size:13px; color:#6B7280;">{{ $t('clientsReports.summary_closed') }}</div>
                    <div style="font-size:24px; color:#111827;">{{ closedCount }}</div>
                </div>
            </b-col>
            <b-col cols="3">
                <div style="background-color:#F3F4F6; border-radius:6px; padding:10px;">
                    <div style="font-size:13px; color:#6B7280;">{{ $t('clientsReports.summary_process') }}</div>
                    <div style="font-size:24px; color:#111827;">{{ processCount }}</div>
                </div>
            </b-col>
        </b-row>
        <vue-good-table
        id="clientsReportsFormTable" ref="clientsReportsFormTable" :columns="columns" :rows="rows" styleClass="vgt-table condensed tableSize"
        :select-options="{ enabled: false, selectOnCheckboxOnly: true, selectionInfoClass: 'custom-class', selectionText: 'rows selected', clearSelectionText: 'clear',
            disableSelectInfo: true, selectAllByGroup: true}" 
        :search-options="{ enabled: true, externalQuery: searchTerm }"
        :pagination-options="{ enabled: true, perPage:pageLength }">
        <div slot="emptystate"> {{ $t('dataTable.data_not_found') }} </div>
        <!-- Row: Table Row -->
        <template slot="table-column" slot-scope="props">
          <span v-if="props.column.field ==='lawMatterNo'" class="text-nowrap">
            {{ $t('clientsReports.no') }}
          </span>
          <span v-if="props.column.field ==='name'" class="text-nowrap">
            {{ $t('clientsReports.name') }}
          </span>
          <span v-if="props.column.field ==='lawMatterStatus'" class="text-nowrap">
            {{ $t('clientsReports.status') }}
          </span>
          <span v-if="props.column.field ==='matterTypes'" class="text-nowrap">
            {{ $t('clientsReports.process_type') }}
          </span>
        </template>

        <!-- Row: Table Row -->
        <template slot="table-row" slot-scope="props" >
            <span v-if="props.column.field === 'lawMatterNo'" class="text-nowrap">
                <a href="javascript:void(0)" @click="showLawMatterForm(props.row)"
                   style="color:#C2410C; text-decoration:none; cursor:pointer;"
                   onmouseover="this.style.textDecoration='underline'" onmouseout="this.style.textDecoration='none'">
                    {{ props.row.lawMatterNo }}
                </a>
            </span>
            <span v-else-if="props.column.field === 'matterTypes'">
                <span v-for="mt in props.row.matterTypes" :key="mt.code" :title="mt.name"
                      style="display:inline-block; background-color:#F3F4F6; color:#374151; padding:2px 7px; border-radius:4px; margin-right:4px; margin-bottom:2px;">
                    {{ mt.code }}
                </span>
            </span>
            <span v-else-if="props.column.field === 'name'" class="text-nowrap">
                {{ props.row.name }}
            </span>
            <span v-else-if="props.column.field === 'lawMatterStatus'" class="text-nowrap">
                {{ props.row.lawMatterStatus }}
            </span>
        </template>

        <!-- pagination -->
        <template slot="pagination-bottom" slot-scope="props">
            <div class="d-flex justify-content-between flex-wrap">
            <div class="d-flex align-items-center mb-0 mt-1">
                <span class="text-nowrap">
                    {{ $t('clientsReports.showing', { total: props.total, shown: Math.min(pageLength, props.total) }) }}
                </span>
                <b-form-select v-model="pageLength" :options="['10', '50', '100', '1000']" class="mx-1"
                @input="(value) => props.perPageChanged({ currentPerPage: value })" />
            </div>
            <div>
                <b-pagination :value="1" :total-rows="props.total" :per-page="pageLength" first-number last-number
                align="right" prev-class="prev-item" next-class="next-item" class="mt-1 mb-0"
                @input="(value) => props.pageChanged({ currentPage: value })">
                <template #prev-text>
                    <feather-icon icon="ChevronLeftIcon" size="18" />
                </template>
                <template #next-text>
                    <feather-icon icon="ChevronRightIcon" size="18" />
                </template>
                </b-pagination>
            </div>
            </div>
        </template>
      </vue-good-table>
    </b-modal>
    </div>
    </template>
    
    <script>
    export default {
        props: {
            getLawCourtList: {
                type: Function
            },
        },
        data() {
            return {
                total: 0,
                pageLength: 50,
                dir: false,
                pageNo: 1,
                columns: [
                    {
                        label: this.$t('clientsReports.no'),
                        field: 'lawMatterNo',
                    },
                    {
                        label: this.$t('clientsReports.process_type'),
                        field: 'matterTypes',
                    },
                    {
                        label: this.$t('clientsReports.name'),
                        field: 'name',
                    },
                    {
                        label: this.$t('clientsReports.status'),
                        field: 'lawMatterStatus',
                    }
                ],
                rows: [],
                searchTerm: '',
                name:'',
                agentOwnerSelect: 1,
                headerName: '',
            }
        },
        computed: {
            fileCount() {
                return this.rows.length
            },
            processCount() {
                return this.rows.reduce((sum, r) => sum + (r.matterTypes ? r.matterTypes.length : 0), 0)
            },
            openCount() {
                return this.rows.filter(r => r.lawMatterStatus === 'Açık').length
            },
            closedCount() {
                return this.rows.filter(r => r.lawMatterStatus === 'Kapalı').length
            },
            subtitle() {
                const label = this.agentOwnerSelect === 2 ? this.$t('clientsReports.client') : this.$t('clientsReports.agent')
                return this.headerName ? (label + ' · ' + this.headerName) : label
            }
        },
        methods: {
            clear() {
                this.lawMatterCaseTypeSelect = 0;
                this.lawCourtTypeSelect = 0;
                this.name = '';
                this.type = 0;
            },
            showInfo(agentOwnerSelect, lawMatterTypeId, id, name) {
                this.$refs['clientsReportsFormModal'].show()
                this.agentOwnerSelect = agentOwnerSelect
                this.headerName = name || ''
                this.rows = []
                let data = null

                if (agentOwnerSelect == 2)
                    data = { lawClientId: id, lawMatterTypeId: lawMatterTypeId, agentOwnerSelect: agentOwnerSelect }
                else if (lawMatterTypeId === 0)
                    data = { lawClientId: id, clientAccountingId: 0, lawMatterTypeId: 0, agentOwnerSelect: agentOwnerSelect }
                else
                    data = { clientAccountingId: id, lawMatterTypeId: lawMatterTypeId, agentOwnerSelect: agentOwnerSelect }

                const controller = { name: 'LawClient', actionName: 'GetLawClientLawMatterReportList'}
                const payload = { data: data, controller: controller}
                this.$store.dispatch('moduleAuth/customService', payload).then((response) => {
                    if (response.data.resultStatus == true) {
                        this.rows = response.data.lawClientLawMatterReportList
                    } else {
                        this.$bvModal.hide('clientsReportsFormModal')
                        this.$WarningAlert(response.data.resultMessage)
                    }
                })
            },
            showLawMatterForm(row) {
                this.$refs.lawMatterForm.showInfo(row.lawMatterId)            
            },
        }
    }
    </script>
    
    <style lang="scss">
    [dir=ltr] .modal-header .close {
        margin: -0.4rem -0.4rem -0.8rem auto;
    }
    
    [dir] label {
        margin-bottom: 0.2857rem;
        font-weight: bold;
    }
    
    .modal .modal-content {
        overflow: visible;
        margin-bottom: auto;
    }
    
    [dir] .invalid-tooltip {
        padding: 0.4rem 0.775rem !important;
        margin-top: -1.5rem !important;
        background-color: #ea5455 !important;
        border-radius: 0.358rem !important;
        left: 20px !important
    }
    </style>
    